var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4037 15.8733C22.8546 14.481 25.1455 14.481 26.5964 15.8733L31.2229 20.3126C31.5634 20.6394 31.7925 21.0651 31.8777 21.5294C32.4622 24.717 32.5053 27.9803 32.0053 31.1823L31.8245 32.3398C31.7498 32.8185 31.3375 33.1714 30.853 33.1714H26.6843C26.2701 33.1714 25.9343 32.8356 25.9343 32.4214V26.21H22.0659V32.4214C22.0659 32.8356 21.7301 33.1714 21.3159 33.1714H17.1471C16.6626 33.1714 16.2504 32.8185 16.1756 32.3398L15.9948 31.1823C15.4948 27.9803 15.5379 24.717 16.1225 21.5294C16.2076 21.0651 16.4367 20.6394 16.7773 20.3126L21.4037 15.8733Z",
    fill: "#3D87BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveHome);
export default __webpack_public_path__ + "static/media/active-home.63def4c5057f99ed20c1a4391c076b9d.svg";
export { ForwardRef as ReactComponent };